import * as React from "react";

import { AppButtonProps, useAppButtonState } from "../../AppButton/next";
import { getDownChevronIcon, iconNameToIconProps } from "@1js/acui-icons";
import { AppMenuButtonProps, AppMenuButtonState } from ".";
import { Icon } from "@fluentui/react";

export const useAppMenuButtonState = (
  props: AppMenuButtonProps,
  state: AppMenuButtonState
): AppMenuButtonState => {
  const { onClick, onKeyDown, ariaLabel, labelInMenu, label } = props;
  // Fill in iconPosition because that is the only thing MenuButtonState doesn't have
  // that ButtonState has
  const appButtonState = useAppButtonState(props as AppButtonProps, {
    ...state,
    iconPosition: "before",
  }) as AppMenuButtonState;

  // Override properties that get set in useAppButtonState
  // and need to be preserved from the props because they were set by menu code
  appButtonState.root.onClick = onClick;
  appButtonState.root.onKeyDown = onKeyDown;

  appButtonState.root["aria-label"] = ariaLabel || labelInMenu || label;

  // App Menu Button specific properties
  appButtonState.menuHidden = props.menuHidden;

  const downChevronIcon = getDownChevronIcon(props);
  appButtonState.menuIcon = downChevronIcon
    ? {
        children: <Icon {...iconNameToIconProps(downChevronIcon)} />,
      }
    : undefined;

  appButtonState.root["aria-haspopup"] = true;

  return appButtonState;
};
